/**
 * Returns the next value based on the given range.
 *
 * @param value The value.
 * @param range The range.
 * @param [start=0] The start value.
 * @returns Returns the next value.
 * @example
 *
 * next(7, 10)
 * // => 10
 *
 * next(25, 20)
 * // => 40
 *
 * next(25, 20, 10)
 * // => 30
 *
 * next(100, 30, 53)
 * // => 113
 */
export function next(value: number, range: number, start = 0): number {
  return start + Math.ceil((Math.max(start, value) - start) / range) * range;
}
